import page from 'page'
import appStarterPg from '../../config/app-starter-pg.js'
import { contentElementId } from '../../config/config.js'
import { browserAppUser } from '../../helpers/app-data-loaders/app-user.js'
import { showInvite } from './app-user-invite/show-invite.js'

/**
 * /app/...
 */
export function setupInviteRoutes (baseRoute) {
  /**
   * Account invites
   * /app/invite/:inviteId
   */
  page(`${baseRoute}/:inviteId`, async function (context) {
    await appStarterPg()

    const { inviteId } = context.params
    if (!browserAppUser.isLoggedIn()) {
      localStorage.setItem('afterLoginRedirectUrl', `/app/invite/${inviteId}`)
      location.href = '/app/auth'
      return
    }

    await showInvite({
      containerElementId: contentElementId,
      inviteId
    })
  })
}
